import { Grid } from '../board';

export function findNearestEmptyElement(grid: Grid): { i: number, j: number } | null {
    let n = 0, size = grid.length, value;
    let i = (size-1) / 2, j = (size-1) / 2;
    do{
        n++;//увеличиваем величину сдвига на 1
        for (let k = 0; k < n; k++) {//выводим n элементов со сдвигом вверх
            value = grid[i--][j];
            if (value === 1) {
                return {
                    i: i + 1,
                    j
                };
            }
                        //точка выхода из цикла
            if (n === size) {//если сдвиг равен размерности массива
                break;//выход
            }
        }
        for (let k = 0; k < n; k++) {//выводим n элементов со сдвигом вправо
            value = grid[i][j++];
            if (value === 1) {
                return {
                    i,
                    j: j - 1
                };
            }
        }
        n++;//опять увеличиваем сдвиг
        for (let k = 0; k < n; k++) {////выводим n элементов со сдвигом вниз
            grid[i++][j];
            if (value === 1) {
                return {
                    i: i - 1,
                    j
                };
            }
        }
        for (let k = 0; k < n; k++) {////выводим n элементов со сдвигом влево
            grid[i][j--];
            if (value === 1) {
                return {
                    i,
                    j: j + 1
                };
            }
        }

    } while (n);

    return null;
}